import React, { useEffect, useRef, useState } from "react";
import { Button, Col, ConfigProvider, Divider, Drawer, Modal, Row, Table, Tag, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { EditOutlined, ExclamationCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { useGetAlarms } from "../ServerSideStates";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { cancelAlarmItems } from "../Services";
import dayjs from "dayjs";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import PriceFormatter from "apps/Common/PriceFormatter";
import SelectAlarmWays from "apps/RealState/Details/Components/Options/Components/AlarmWays";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import useWindowSize from "helpers/useWindowSize";
import TruncatedText from "apps/Common/TruncatedText";
import CustomNoData from "apps/Common/CustomNoData";

const { Text } = Typography;

const ListItems = () => {
  const containerRef = useRef(null);
  const windowSize = useWindowSize(containerRef);
  const [isDesktop, setIsDesktop] = useState(false);
  const queryClient = useQueryClient();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isShowEditDrawer, setIsShowEditDrawer] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const alarms = useGetAlarms();
  

  const columns = [
    {
      title: "Bildirim Adı",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: any) => {
        const advertMedia = record?.advert?.advertMedia || [];
        console.log("advert media", record);
        const mainMedia =
          advertMedia.find((item: any) => item.isMain) || advertMedia[0];
        return (
          <>
         
          <div className="!flex items-center gap-3 w-full px-2" >
       
            {/* <LazyLoadImage
                classNames="!border !border-gray-200 !rounded-sm !p-1 !w-[70px] !h-[70px] md:!h-[70px] md:!w-[70px] "
                wrapperWidth="70px"
                wrapperHeight="70px"
                imageClassName="!object-contain"
                src={
                  mainMedia
                    ? `${setBackEndUlr()}/${mainMedia.media?.fullPath}`
                    : ""
                }
                alt=""
              /> */}
            
           

            <div className="!flex !flex-col gap-1">

              <div className="!hidden xl:!block" >
                <Text>Fiyat değiştiğinde haber ver</Text>
              </div>
              {/* <TruncatedText
                  textClassName="!text-blue-500 !text-xs md:!text-sm"
                  title={record?.advert?.title}
                  maxLines={1}
                />
                <div>
                  <Text className="!font-bold">
                    <PriceFormatter inputPrice={record?.advert?.price} />
                  </Text>
                </div> */}
  
              <div className="!flex !flex-col gap-1 xl:!hidden">

              <div className="!flex gap-1">
                {record?.notificationTypeAlarm?.map((item: any) => {
                  return (
                    <>
                      <Tag
                      className="!text-[8px] md:!text-sm"
                        color={
                          item?.notificationTypeId === 1 ? "blue" : "green"
                        }
                      >
                        {item?.notificationType?.name}
                      </Tag>
                    </>
                  );
                })}
              </div>
              <div>
                <Text className="!text-gray-400 !text-xs" >{dayjs(record?.insertDate).format("DD.MM.YYYY")}</Text>
              </div>
              <div className=" gap-3 !flex ">
            <Button
              color="default"
              variant="outlined"
              icon={<WarningOutlined  />}
              onClick={() => {
                confirmCanceldAlarms([record.advertId]);
              }}
              type="text"
              className=" !text-red-500 !border-none !p-0 !flex gap-1 !text-xs md:!text-sm !bg-transparent"
            >
              İptal Et
            </Button>
            <Button
            icon={<EditOutlined/>}
              onClick={async () => {
                setSelectedRecord(record);
                setIsShowEditDrawer(true);
              }}
              type="text"
               className=" !text-blue-500 !border-none !p-0 !flex gap-1 !text-xs md:!text-sm !bg-transparent"
            >
              Güncelle
            </Button>
          </div>
              </div>
           
            </div>
          </div>
          

       
         
          </>
        );
      },
    },
    ...(isDesktop?[
      {
        title: "İlan ",
  
        render: (text: string, record: any) => {
          const advertMedia = record?.advert?.advertMedia || [];
          const mainMedia =
            advertMedia.find((item: any) => item.isMain) || advertMedia[0];
  
          return (
            <div className="!flex items-center gap-3 !w-full ">
              <LazyLoadImage
                classNames="!border !border-gray-200 !rounded-sm !p-1 !w-[70px] !h-[70px] md:!h-[70px] md:!w-[70px] "
                wrapperWidth="70px"
                wrapperHeight="70px"
                imageClassName="!object-contain"
                src={
                  mainMedia
                    ? `${setBackEndUlr()}/${mainMedia.media?.fullPath}`
                    : ""
                }
                alt=""
              />
              <div>
                <TruncatedText
                  textClassName="!text-blue-500"
                  title={record?.advert?.title}
                  maxLines={1}
                />
  
                <div>
                  <Text className="!font-bold">
                    <PriceFormatter inputPrice={record?.advert?.price} />
                  </Text>
                </div>
               
                
  
              </div>
            </div>
          );
        },
      },

    
  
      {
        title: "Bildirim Yolu",
        dataIndex: "notificationTypeAlarm",
  
        render: (types: any[], record: any) => {
          if (types?.length > 0) {
            return (
              <div className=" !flex-col md:!flex-row gap-2 !items-start  md:!items-center  xl:flex">
                <Text className="mobile-label" data-label="Bildirim Yolu"></Text>
                {types.map((item: any) => {
                  return (
                    <>
                      <Tag
                        color={item?.notificationType.id === 1 ? "blue" : "green"}
                      >
                        {item?.notificationType?.name}
                      </Tag>
                    </>
                  );
                })}
              </div>
            );
          }
          return <></>;
        },
      },
      {
        title: "Kayıtlı Tarihi",
        dataIndex: "insertDate",
        key: "insertDate",
        render: (value: string) => (
          <Text className="!hidden xl:!flex">
            {dayjs(value).format("DD.MM.YYYY")}
          </Text>
        ),
      },
      {
        title: "İşlem",
        key: "action",
        render: (_: any, record: any) => (
          <div className="flex gap-3 ">
            <Button
              color="default"
              variant="outlined"
              onClick={() => {
                confirmCanceldAlarms([record.advertId]);
              }}
              type="text"
              className=" hover:!bg-red-500 hover:!text-white xl:!text-red-500 xl:!bg-transparent !border-red-400"
            >
              İptal Et
            </Button>
            <Button
              onClick={async () => {
                setSelectedRecord(record);
                setIsShowEditDrawer(true);
              }}
              type="text"
              className="hover:!bg-black hover:!text-white  !border !border-gray-400 !text-black"
            >
              Güncelle
            </Button>
          </div>
        ),
      },

    ]:[]),
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  const confirmCanceldAlarms = (records: any[]) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Alarm iptal edilecektir. Onaylıyor musunuz?`,
      okText: "İptal et",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          await cancelAlarmItems(records);
          openNotificationWithIcon("default", "İşlem Başarılı");
          queryClient.resetQueries({
            queryKey: endPoints.getAlarmList,
            exact: false,
          });
          setSelectedRowKeys([]);
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  useEffect(() => {
    if (windowSize.width > 1040) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }, []);

  return (
    <Row>
      {selectedRowKeys.length > 0 && (
        <>
          <Col
            xs={24}
            className="!bg-[#fafafa] !p-2 !flex gap-2 items-center justify-end "
          >
            <Text className="!font-bold !text-sm">
              {selectedRowKeys.length} oğe secildi
            </Text>
            <MazakaButton
              className="!bg-red-500 !text-white"
              icon={<WarningOutlined />}
              onClick={() => {
                confirmCanceldAlarms(selectedRowKeys);
              }}
            >
              İptal Et
            </MazakaButton>
          </Col>
        </>
      )}
      <Col xs={24} ref={containerRef}>


        <Table
        
          rowSelection={isDesktop ? rowSelection : undefined}
          columns={columns}
          rowKey={"advertId"}
          dataSource={alarms?.data?.data ? alarms?.data?.data : []}
          rowClassName="responsive-row"
        />
     
      </Col>
      <Drawer
        open={isShowEditDrawer}
        onClose={() => {
          setIsShowEditDrawer(false);
        }}
      >
        <SelectAlarmWays
          selectedRecord={selectedRecord}
          onFinish={() => {
            queryClient.resetQueries({
              queryKey: endPoints.getAlarmList,
              exact: false,
            });
            setIsShowEditDrawer(false);
          }}
        />
      </Drawer>
    </Row>
  );
};

export default ListItems;
